import moment from "moment";

export const formatRupiah = (value) => {
  if (value === null || value === undefined) return "Rp 0";
  return `Rp ${Number(value).toLocaleString("id-ID")}`;
};

export const formatPercent = (value) => {
  if (value === null || value === undefined) return "0%";

  const num = Number(value);

  if (num === 0) return "0%";

  return `${(num * 100).toFixed(2)}%`;
};

export const mapToSimpleNestedTable = ({ apiData, month, year }) => {
  if (!apiData?.length || !apiData[0]?.partHarian) {
    return { data: [], config: [] };
  }

  const partHarian = apiData[0].partHarian;

  // TOTAL HARI DALAM BULAN
  const daysInMonth = moment(`${year}-${month}`, "YYYY-M").daysInMonth();

  // DATA (Tanggal 1–31)
  const data = Array.from({ length: daysInMonth }, (_, i) =>
    moment(`${i + 1}-${month}-${year}`, "D-M-YYYY").format("DD/MM/YYYY"),
  );

  // CONFIG BASE
  const configMap = {
    total: {
      key: "total",
      label: "Total Part",
      dailyCash: {},
      dailyAccumulation: {},
    },
    tire: {
      key: "tire",
      label: "TIRE",
      dailyCash: {},
      dailyAccumulation: {},
      percentSP: {},
    },
    oil: {
      key: "oil",
      label: "OIL",
      dailyCash: {},
      dailyAccumulation: {},
      percentSP: {},
    },
    battery: {
      key: "battery",
      label: "BATTERY",
      dailyCash: {},
      dailyAccumulation: {},
      percentSP: {},
    },
  };

  // PART LAINNYA (DINAMIS)
  const firstDay = Object.values(partHarian)[0];
  (firstDay?.partLainnya || []).forEach((p) => {
    const key = p.partNameLainnya.toLowerCase();
    configMap[key] = {
      key,
      label: p.partNameLainnya,
      dailyCash: {},
      dailyAccumulation: {},
      percentSP: {},
    };
  });

  // DEFAULT VALUE = 0
  Object.values(configMap).forEach((col) => {
    for (let day = 1; day <= daysInMonth; day++) {
      col.dailyCash[day] = formatRupiah(0);
      col.dailyAccumulation[day] = formatRupiah(0);
      if (col.percentSP) {
        col.percentSP[day] = formatPercent(0);
      }
    }
  });

  // ISI DATA DARI API
  Object.entries(partHarian).forEach(([day, value]) => {
    const idx = Number(day);
    if (!idx || idx > daysInMonth) return;

    configMap.total.dailyCash[idx] = formatRupiah(value?.totalPart ?? 0);
    configMap.total.dailyAccumulation[idx] = formatRupiah(
      value?.akumulasiTotal ?? 0,
    );

    configMap.tire.dailyCash[idx] = formatRupiah(value?.totalTire ?? 0);
    configMap.tire.dailyAccumulation[idx] = formatRupiah(
      value?.akumulasiTire ?? 0,
    );
    configMap.tire.percentSP[idx] = formatPercent(value?.persenTire ?? 0);

    configMap.oil.dailyCash[idx] = formatRupiah(value?.totalOil ?? 0);
    configMap.oil.dailyAccumulation[idx] = formatRupiah(
      value?.akumulasiOil ?? 0,
    );
    configMap.oil.percentSP[idx] = formatPercent(value?.persenOil ?? 0);

    configMap.battery.dailyCash[idx] = formatRupiah(value?.totalBattery ?? 0);
    configMap.battery.dailyAccumulation[idx] = formatRupiah(
      value?.akumulasiBattery ?? 0,
    );
    configMap.battery.percentSP[idx] = formatPercent(value?.persenBattery ?? 0);

    (value?.partLainnya || []).forEach((p) => {
      const key = p.partNameLainnya.toLowerCase();
      if (!configMap[key]) return;

      configMap[key].dailyCash[idx] = formatRupiah(p.totalPartLainnya ?? 0);
      configMap[key].dailyAccumulation[idx] = formatRupiah(
        p.akumulasiPartLainnya ?? 0,
      );
      configMap[key].percentSP[idx] = formatPercent(p.persenPartLainnya ?? 0);
    });
  });

  return {
    data,
    config: Object.values(configMap),
  };
};
